
import { defineComponent, reactive, toRaw } from "vue";
import Button from "@/components/Button.vue";
import InputTextfield from "@/components/InputTextfield.vue";
import LoginCarousel from "@/components/LoginCarousel.vue";
import { sendInstructionsForgotPassword } from "@/services/email/emailService";
import { GenericResponse } from "@/services/email/types";
import { useToast } from "vue-toastification";
import { useStore } from "@/store";
import { LoadingMutationTypes } from "@/store/modules/loading/mutation-types";
import { AuthEmailPayload } from "@/services/email/types";

interface ForgotPasswordForm {
  email: string;
}

export default defineComponent({
  name: "ForgotPassword",
  components: {
    Button,
    InputTextfield,
    LoginCarousel,
  },
  setup() {
    const toast = useToast();
    const store = useStore();
    const form = reactive<ForgotPasswordForm>({
      email: "",
    });

    const handleInputEmailValue = (value: string) => {
      form.email = value;
    };

    const handleButtonClick = async (formLogin: ForgotPasswordForm) => {
      try {
        const rawFormLogin = toRaw(formLogin);

        const forgotPasswordPayload: AuthEmailPayload = {
          email: rawFormLogin.email,
        };

        const response = await sendEmailForgotPasswordByEmail(
          forgotPasswordPayload
        );

        store.commit(LoadingMutationTypes.SET_LOADING, false);
        showSuccessToast('Email de instruções enviado com sucesso.')
      } catch (error) {
        store.commit(LoadingMutationTypes.SET_LOADING, false);
        showErrorToast("Houve uma falha na operação.");
      }
    };

    const sendEmailForgotPasswordByEmail = async (email: AuthEmailPayload) => {
      const response: GenericResponse = await sendInstructionsForgotPassword(
        email
      );

      const newPasswordResponse = {
        ok: response.ok,
      };

      return newPasswordResponse;
    };

    const showErrorToast = (message: string) => {
      toast.error(message, {
        timeout: 5000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
        rtl: false,
      });
    };

    const showSuccessToast = (message: string) => {
      toast.success(message, {
        timeout: 5000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
        rtl: false,
      });
    };

    return {
      handleButtonClick,
      handleInputEmailValue,
      form,
    };
  },
});
